"use client";

import { useEffect } from "react";
import Link from "next/link";
import { AlertTriangle } from "lucide-react";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error("Global error:", error);
  }, [error]);

  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center px-5 text-center">
      <AlertTriangle className="mb-4 h-12 w-12 text-red-400" />
      <h1 className="mb-2 text-xl font-bold">문제가 발생했습니다</h1>
      <p className="mb-6 text-sm text-gray-500">
        일시적인 오류입니다. 새로고침하거나 잠시 후 다시 시도해주세요.
      </p>
      <div className="flex gap-3">
        <button
          onClick={reset}
          className="rounded-xl bg-violet-600 px-6 py-2.5 text-sm font-semibold text-white hover:bg-violet-700"
        >
          다시 시도
        </button>
        <Link
          href="/wiki"
          className="rounded-xl border border-gray-200 px-6 py-2.5 text-sm font-semibold text-gray-700 hover:bg-gray-50"
        >
          홈으로
        </Link>
      </div>
    </div>
  );
}
